import React, {useContext} from 'react';
import './TermsOfUse.css';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';

import TosDe from './de/TosDe';
import TosEn from './en/TosEn';
import { useIndexUpdate } from '../common/hooks';

export function TermsOfUse(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div>
            <div className="bottom_padding side_padding flex_col margin_to_header">
               {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <TosDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <TosEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>

            <Footer />
        </div>
    );
}
